import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import ScoreByColor from '../../components/ExcerciseTypes/Design/ScoreByColor'
// import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import UI from '../../components/ExcerciseTypes/Design/UserInterfaceV2'
import PaintColorType from '../../components/ExcerciseTypes/Design/PaintColorType'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'
const json = {
	1: {
		// Exercise num
		unit: 'Unit 1',
		id: '4WB-U1-P10-E1',
		audio: '',
		hideBtnFooter: true,
		// exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '1',
				title: 'Find and circle the words.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
       
            <div> <img style='width:22cm' src='img/FriendsPlus/Page10/E1/1.jpg' /> </div>
          `,
				answer: [''],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 1',
		id: '4WB-U1-P10-E2',
		audio: '',
		video: '',
		exerciseKey: 'img/FriendsPlus/Page10/Key/E2answerKey.png',

		component: DesignUnderLine,
		totalInput: 3,
		titleQuestion: [
			{
				num: '2',
				title: ' Fill in the correct circle.',
				color: '#234090',
			},
		],
		// isAllowSubmit: false,
		questionImage: [
			// Row
			[{ url: 'img/FriendsPlus/Page10/E2/1.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/2.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/3.jpg', input: 1 },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/4.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/5.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/6.jpg', input: 1, isCorrect: true },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/7.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/8.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/9.jpg', input: 1 },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/10.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/11.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/12.jpg', input: 2 },
				{ url: 'img/FriendsPlus/Page10/E2/13.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/14.jpg', input: 3, isCorrect: true },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/15.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/16.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/17.jpg', input: 2 },
				{ url: 'img/FriendsPlus/Page10/E2/18.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/19.jpg', input: 3 },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/20.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page10/E2/21.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/22.jpg', input: 2, isCorrect: true },
				{ url: 'img/FriendsPlus/Page10/E2/23.jpg' },
				{ url: 'img/FriendsPlus/Page10/E2/24.jpg', input: 3 },
			],
			[{ url: 'img/FriendsPlus/Page10/E2/25.jpg' }],
		],
	},
}

export default json
